import { Routes, Route, Navigate } from 'react-router-dom';
import { CrewDashboardPage } from './crew-dashboard-page';
import { TechsPage } from './techs/techs-page';
import { CreateTechPage } from './techs/create-tech-page';
import { TechDetailPage } from './techs/tech-detail-page';
import { ExpiringCertsPage } from './certifications/expiring-certs-page';
import { CrewListsPage } from './lists/crew-lists-page';
import { SchedulePage } from './schedule/schedule-page';
import { MyAvailabilityPage } from './availability/my-availability-page';
import { CreateAssignmentPage } from './assignments/create-assignment-page';
import { TravelPage } from './travel/travel-page';
import { TravelItineraryPage } from './travel/travel-itinerary-page';
import { CrewTemplatesPage } from './templates/crew-templates-page';
import { OnboardingAdminPage } from './onboarding/onboarding-admin-page';
import { CheckInMapPage } from './checkins/check-in-map-page';
import { JobPacketsPage } from './job-packets/job-packets-page';
import { JobPacketDetailPage } from './job-packets/job-packet-detail-page';

export function CrewPage() {
  return (
    <Routes>
      <Route index element={<CrewDashboardPage />} />
      <Route path="techs" element={<TechsPage />} />
      <Route path="techs/new" element={<CreateTechPage />} />
      <Route path="techs/:id" element={<TechDetailPage />} />
      <Route path="certifications/expiring" element={<ExpiringCertsPage />} />
      <Route path="lists" element={<CrewListsPage />} />
      <Route path="templates" element={<CrewTemplatesPage />} />
      <Route path="schedule" element={<SchedulePage />} />
      <Route path="my-availability" element={<MyAvailabilityPage />} />
      <Route path="assignments/new" element={<CreateAssignmentPage />} />
      <Route path="travel" element={<TravelPage />} />
      <Route path="travel/itinerary" element={<TravelItineraryPage />} />
      <Route path="onboarding" element={<OnboardingAdminPage />} />
      <Route path="check-ins" element={<CheckInMapPage />} />
      <Route path="job-packets" element={<JobPacketsPage />} />
      <Route path="job-packets/:id" element={<JobPacketDetailPage />} />
      <Route path="dispatch" element={<Navigate to="/h3ightboard" replace />} />
      <Route path="kiosk" element={<Navigate to="/crew/check-ins" replace />} />
    </Routes>
  );
}
